module.exports = __webpack_public_path__ + "static/media/polinizador.0776b587.svg";